export default "__VITE_ASSET__BmK3TN3B__"